import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import {
  mergeAriaEscalationTakeOverIntoChat,
  takeOverAriaEscalation,
} from '../services/ariaEscalations';
import { ariaEscalationQueryKeys } from './query-keys';

export const useTakeOverAriaEscalationMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ escalationId, previousChat } = {}) => {
      const result = await takeOverAriaEscalation(escalationId);
      if (!result.success) {
        const error = new Error(result.message || 'Failed to take over escalation');
        error.status = result.status;
        throw error;
      }

      return {
        ...result,
        chat: mergeAriaEscalationTakeOverIntoChat(previousChat, result.data),
      };
    },
    onSuccess: async (result, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: ariaEscalationQueryKeys.all });
      toast.success(result.message || 'Escalation taken over');
      await onSuccess?.(result, variables, context);
    },
    onError: (error, variables, context) => {
      toast.error(error?.message || 'Failed to take over escalation');
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};

export default useTakeOverAriaEscalationMutation;
